import React from "react";
import "./researchCard.scss";
import "../../../styles/fontSizes.scss";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const ResearchCard = ({ image, title, subtitle, color, url }) => {
  return (
    <>
      <a
        href={url}
        target="_blank"
        className={`research-card__container font-size--2`}
      >
        <img src={image} alt="" className="research-card__image-back" />
        <div
          className="research-card__content"
          style={{ backgroundColor: color }}
        >
          <img src={image} alt="" className="research-card__content-image" />
          <div className="research-card__content-text">
            <h1 className="research-card__content-text-title">{title}</h1>
            <h2 className="research-card__content-text-subtitle">{subtitle}</h2>
          </div>
        </div>
      </a>
    </>
  );
};

export default ResearchCard;
